export default function CloudModule(element) {

    let tl = gsap.timeline({repeat: -1});

    element.querySelectorAll('.cloud__line').forEach(line => {
        let width = line.scrollWidth;
        let targetX = (width * -1) / 2;
        tl.to(line, { x: targetX, duration: 40, ease: 'none' }, '<')
    });

    return this;
}

